import { render } from "./PcDownload.vue?vue&type=template&id=74c92e56&scoped=true&ts=true"
import script from "./PcDownload.vue?vue&type=script&setup=true&lang=ts"
export * from "./PcDownload.vue?vue&type=script&setup=true&lang=ts"

import "./PcDownload.vue?vue&type=style&index=0&id=74c92e56&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3191932516/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74c92e56"],['__file',"src/components/scan/pc/PcDownload.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74c92e56"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74c92e56', __exports__)) {
    console.log('reload')
    api.reload('74c92e56', __exports__)
  }
  
  module.hot.accept("./PcDownload.vue?vue&type=template&id=74c92e56&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('74c92e56', render)
  })

}


export default __exports__